import axios from 'axios'
import { baseUrl } from '../config'
import errorMsg from './errormsg'
import router from "../router";

/**
 * commonjs for ajax request
 * @params url send request address
 * @param method send request method
 * @param options send request other config
 * @author hzb@jiagouyun.com
 */
export function axiosAjax (url, method, options, noAlert) {
  let defaultOptions = {
    url: url,
    method: method || 'GET',
    withCredentials: true,
    timeout: 60000,
    baseURL: baseUrl.apiUrl
  }
  if (options) {
    defaultOptions = Object.assign({}, defaultOptions, options)
  }
  return new Promise((resolve, reject) => {
    axios(defaultOptions).then(res => {
      const data = res.data;
      if (data.code === "NeedLogin") {
        router.push("/login");
      } else {
        resolve(res)
      }
    }).catch(err => {
      // if (err.response) {
      let codeArr = ['NeedLogin', 'FileEmptyError', 'FileTypeError', 'FileDataError', 'FileResourceExist', 'ResourceExist', 'ResourceExceeded']
      let havaCode = false
      codeArr.forEach(item => {
        if (err.response.data.code === item) {
          havaCode = true
        }
      })
      if (noAlert || (noAlert && err.response.data.code === 'NeedPrivilege')) {
      } else {
        if (havaCode) {
          // const data = err.response.data
          // errorMsg.showErrorMsg(data.code, data.message, 'error')
        } else {
          const data = err.response.data
          errorMsg.showErrorMsg(data.code || data.Code, data.error_message, 'error')
        }
      }
      // }else {
      //   console.log('response', err)
      //   errorMsg.showErrorMsg('RequestTimeout')
      // }
      reject(err.response)
    })
  })
}




// WEBPACK FOOTER //
// ./src/api/common.js